import GuidedTour from './GuidedTour.component';

export default GuidedTour;
